import React, { memo, useState } from 'react'
import styles from './PrivateSidemenuButton.module.scss'
import { useLocation, useNavigate } from 'react-router-dom';

type SubMenuProps = {
    text: string;
    icon?: React.ReactNode;
    colapsedText?: string;

    route: string;
    disabled?: boolean;
}

export type PrivateSidemenuButtonProps = {
    text: string;
    icon?: React.ReactNode;
    route?: string;
    disabled?: boolean;
    executeWrapper?: (func: () => void) => void;

    colapsed: boolean;
    isDisabled: boolean;

    subMenuItems?: SubMenuProps[];
}

const PrivateSidemenuButton: React.FC<PrivateSidemenuButtonProps> = memo((props: PrivateSidemenuButtonProps) => {
    const { text, icon, route, disabled, subMenuItems, isDisabled, colapsed, executeWrapper } = props;
   
    const [menuClosed, setMenuClosed] = useState(false);

    const navigator = useNavigate();
    const location = useLocation();

    const isCurrent = (route?: string) => {
        if (disabled) return '';
        if (route && location.pathname === route)
            return styles.sectionButtonSelected
        return '';
    }

    const navigateTo = (path?: string) => {
        if (path) {
            navigator(path);
        }
    }

    const buttonClick = () => {
        if (isDisabled || disabled) return;
        if (subMenuItems && subMenuItems.length > 0) {
            setMenuClosed(!menuClosed);
        } else {
            navigate(route)
        }
    }

    const navigate = (route?: string) => {
        if (executeWrapper) {
            executeWrapper(() => navigateTo(route));
        } else{
            navigateTo(route);
        }
    }


    return (
        <div className={`${colapsed ? styles.colapsed : ''} ${isDisabled ? styles.disabled : ''}`}>
            <button
                disabled={isDisabled}
                className={`standardButton ${styles.sectionButton} ${isCurrent(route)}`}
                onClick={buttonClick}
            >
                {icon}
                <div className={styles.text}>
                    {text}
                </div>
                {
                    subMenuItems && subMenuItems.length > 0 && <svg className={`${styles.rotatingButton} ${menuClosed ? styles.rotate : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z" fill="#000000" />
                    </svg>
                }

            </button>
            {
                subMenuItems && subMenuItems.length > 0 && <div className={`${styles.subMenu} ${menuClosed ? '' : styles.subMenuContentOpen}`}>
                    <div>
                        {
                            subMenuItems.map((subMenuItem, index) => {
                                return (
                                    <button
                                        key={index}
                                        disabled={subMenuItem.disabled}
                                        className={`standardButton ${styles.sectionButton} ${isCurrent(subMenuItem.route)}`}
                                        onClick={() => navigate(subMenuItem.route)}
                                    >
                                        {!colapsed && <div className={styles.subMenuSpacer} />}
                                        {subMenuItem.icon}
                                        {
                                            !subMenuItem.icon && subMenuItem.colapsedText && colapsed && <div className={styles.colapsedText}>{subMenuItem.colapsedText}</div>
                                        }
                                        <div className={styles.text}>
                                            {subMenuItem.text}
                                        </div>
                                    </button>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </div>

    )
})

export default PrivateSidemenuButton